import { ProfessionIcon } from './profession-icon';

export const IconHealthcare = () => (
  <ProfessionIcon bg="#E0F2F1">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 3a1 1 0 011-1h4a1 1 0 011 1v5h5a1 1 0 011 1v4a1 1 0 01-1 1h-5v5a1 1 0 01-1 1h-4a1 1 0 01-1-1v-5H4a1 1 0 01-1-1v-4a1 1 0 011-1h5V3z"
        stroke="#009688"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  </ProfessionIcon>
);
